<template>
  <div class="global-menu">
    <language-switcher></language-switcher>

    <div class="button-container" v-if="!opened" @click="open()">
      <span class="top"></span>
      <span class="middle"></span>
      <span class="bottom"></span>
    </div>

    <div class="overlay open" v-if="opened">
      <nav class="overlay-menu">
        <ul>
          <li>
            <a @click="close('Home')" href="#home">{{$t('Home')}}</a>
          </li>
          <li>
            <a @click="close('Portfolio')" href="#portfolio">{{$t('Portfolio')}}</a>
          </li>
          <li>
            <a @click="close('Prices')" href="#prices">{{$t('Prices')}}</a>
          </li>
          <li>
            <a @click="close('About')" href="#about">{{$t('About')}}</a>
          </li>
          <li>
            <a @click="close('Contact')" href="#contact">{{$t('Contact')}}</a>
          </li>
        </ul>
      </nav>

      <button type="button" class="close" aria-label="Close" @click="opened = false">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '../../bootstrap-overrides';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';

$color-background: #f5f5f5;
$color-main: #000;
$color-active: #fff;
$color-link: #fff;

$button-height: 45px;
$button-width: 50px;

.language-switcher {
  position: absolute;
  left: 1.5em;
  top: 1.5em;
}

.button-container {
  position: absolute;
  top: 1.5em;
  right: 1.5em;
  height: $button-height;
  width: $button-width;
  cursor: pointer;
  z-index: 9998;
  transition: opacity 0.25s ease;
  border: 1px solid $color-background;
  border-radius: 5px;

  &:hover {
    opacity: 0.7;
  }

  &.active {
    .top {
      transform: translateY(11px) translateX(0) rotate(45deg);
      background: $color-active;
    }
    .middle {
      opacity: 0;
      background: $color-active;
    }

    .bottom {
      transform: translateY(-11px) translateX(0) rotate(-45deg);
      background: $color-active;
    }
  }

  span {
    background: $color-background;
    border: none;
    height: 5px;
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    transition: all 0.35s ease;
    cursor: pointer;

    &:nth-of-type(2) {
      top: 19px;
    }

    &:nth-of-type(3) {
      top: 30px;
    }
  }
}

.container {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 40%;
  left: 0;
  margin: 0 auto;

  p {
    font-size: 20px;
  }

  a {
    display: inline-block;
    position: relative;
    text-align: center;
    color: $color-main;
    text-decoration: none;
    font-size: 20px;
    overflow: hidden;
    top: 5px;

    &:after {
      content: '';
      position: absolute;
      background: $color-main;
      height: 2px;
      width: 0%;
      transform: translateX(-100%);
      left: 50%;
      bottom: 0;
      transition: 0.15s ease;
    }
    &:hover:after,
    &:focus:after,
    &:active:after {
      width: 100%;
    }
  }
}

.overlay {
  font-family: $font-family-header !important;
  position: fixed;
  background: $color-main;
  top: 0;
  left: 0;
  width: 100%;
  height: 0%;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s, visibility 0.35s, height 0.35s;
  overflow: hidden;

  &.open {
    z-index: 1000;
    opacity: 0.9;
    visibility: visible;
    height: 100%;

    li {
      animation: fadeInRight 0.3s ease forwards;
      animation-delay: 0.15s;

      &:nth-of-type(2) {
        animation-delay: 0.2s;
      }
      &:nth-of-type(3) {
        animation-delay: 0.25s;
      }
      &:nth-of-type(4) {
        animation-delay: 0.07s;
      }
    }
  }
  nav {
    font-size: 50px;
    text-align: center;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    li {
      display: block;
      min-height: 50px;
      position: relative;
      opacity: 0;

      a {
        color: $color-link;
        text-decoration: none;
        overflow: hidden;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    left: 20%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}

button.close span {
  z-index: 9997;
  color: white !important;
  font-size: 70px;
  margin-right: 0.25em;

  &:hover {
    opacity: 1;
  }
}
</style>
<script>
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  name: 'GlobalMenu',
  components: {
    LanguageSwitcher
  },
  props: {},
  methods: {
    open() {
      this.$ga.event('Menu', 'click', 'open');
      this.opened = true;
    },
    close(clickedTitle) {
      this.$ga.event('MenuItem', 'click', clickedTitle);
      this.opened = false;
      this.$router.push({ name: 'home' });
    }
  },
  watch: {
    opened(val) {
      if (val) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
  },
  data() {
    return {
      opened: false
    };
  }
};
</script>